/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import GoogleLive from "../../IotComponent/liveTracking/googleMapLive";
import {
  Grid,
  TextField,
  Typography,
  LinearProgress,
  Snackbar,
  Button,
  InputAdornment,
} from "@mui/material";
import ChatDrawer from "../../IotComponent/SideTimeline/ChatDrawer";
import {
  Line,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Label,
} from "recharts";
import ClearIcon from "@mui/icons-material/Clear";
import AppHeader from "../../../../common/Pages/AppHeader/AppHeader";
import { useLocation } from "react-router-dom";
import { FleetDashboardOverviewApi } from "../../../../API/Iot-Api/FleetDashboardOverview/FleetDashobardOverview";
import { AllFleetTrackingResponse } from "../../../../@Types/DRO/IotApiResponse/FleetOverviewResponse";
import { CSVLink } from "react-csv";
import RangeDatePicker from "../../IotComponent/AppDatePicker/AppDatePicker";
import { start } from "repl";

const FleetTracking = () => {
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>("");
  const [qrCode, setQrCode] = useState<any>();

  const [fleetTracking, setFleetTracking] =
    useState<AllFleetTrackingResponse | null>(null);
  

  //const qrCode = location.state?.qrCode || {}; // Access qrCode from state passed via navigate
  const [searchVal, setSearchVal] = useState(qrCode);
  const handleDateChange = (dates: [Date | null, Date | null]) => {
    setStartDate(dates[0]);
    setEndDate(dates[1]);
  };
  useEffect(() => {
    const storedQrCode = sessionStorage.getItem("fleetTrackingQrCode");
    setQrCode(storedQrCode);
    setSearchVal(storedQrCode); // 👈 also set the search value here

  }, [qrCode]);

  useEffect(() => {
    const fetchAllFleetLocation = async () => {
      setLoading(true)
      try {
        const data: AllFleetTrackingResponse =
          await FleetDashboardOverviewApi.api.getFleetTracking(
            qrCode,
            searchVal,
            startDate,
            endDate
          );
        const modifiedData = {
          ...data,
          data: {
            ...data.data,
            tracking_data: data.data.tracking_data.map((item) => ({
              ...item,
              createdTime: item.createdTime.split('+')[0], 
            })),
          },
        };
  
        setFleetTracking(modifiedData);
        setLoading(false)
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      }
    };
  
    fetchAllFleetLocation();
  }, [qrCode, searchVal, startDate, endDate]);

  const speedData =
    fleetTracking?.data?.tracking_data?.map((item, index) => ({
      time: item.timestamp || `Point ${index + 1}`, // Use timestamp or fallback
      speed: item.speed,
    })) || [];

  const handleClearSearch = () => {
    setSearchVal("");
  };
  const formatDate = (dateStr: any) => {
    const date = new Date(dateStr);
    return date
      .toLocaleString("en-IN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", ""); // Remove the comma between date and time
  };
  const trackingReportButton = [
    { label: "qrCode", key: "qrCode" },
    { label: "Latitude", key: "latitude" },
    { label: "Longitude", key: "longitude" },
    { label: "lockStatus", key: "lockStatus" },
    { label: "speed", key: "speed" },
    { label: "Distance", key: "Distance" },
    { label: "Increamental_Distance", key: "Increamental_Distance" },
    { label: "createdTime", key: "createdTime" },
  ];
  return (
    <div>
      <AppHeader />
      <div className="flex bg-slate-100 font-rubik text-sm  p-4">
        <div className="w-full px-4 bg-[#fff] rounded-lg shadow py-4">
          <Grid container sx={{ display: "flex", pl: 3 }}>
            <Grid container>
              <Grid item md={12} sx={{ mr: 2 }}>
                <Grid
                  item
                  md={12}
                  sx={{ display: "flex", alignItems: "center" }}>
                  <Grid
                    item
                    sm={6}
                    sx={{ display: "flex", justifyContent: "flex-start" }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      <b> Realtime Tracking</b>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    sm={6}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                    className="py-4">
                    <TextField
                      placeholder="Search Qr Code"
                      id="outlined-basic"
                      variant="outlined"
                      value={searchVal}
                      onChange={(search) => setSearchVal(search.target.value)}
                      InputProps={{
                        style: {
                          height: "40px",
                          borderRadius: "15px",
                          marginRight: "10px",
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            <ClearIcon
                              style={{ cursor: "pointer" }}
                              onClick={handleClearSearch}
                            />
                          </InputAdornment>
                        ),
                      }}
                      // onKeyDown={handleKeyPress}
                    />
                    <div className="flex items-center ">
                      <p className="mr-2 font-semibold">Date Range: </p>
                      <RangeDatePicker
                        onChange={handleDateChange}
                        maxDaysAdd={0}
                        minDaysSub={92}
                        defaultStartDate={0}
                        defaultEndDate={0}
                      />
                    </div>
                  </Grid>
                </Grid>
                {loading && (
                  <LinearProgress
                    className="pl-6 pr-6"
                    sx={{
                      backgroundColor: "white",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "#00CD5B",
                      },
                      width: "100%",
                    }}
                  />
                )}

                <Snackbar
                  open={snackbarOpen}
                  autoHideDuration={6000}
                  onClose={() => setSnackbarOpen(false)}
                  message={snackbarMessage}
                />

                <Grid item sx={{ display: "flex", width: "100%" }}>
                  <Grid item sx={{ width: "30%" }}>
                    <ChatDrawer
                      name={
                        fleetTracking?.data?.rider_data?.[0]?.name ||
                        "Unknown Name"
                      }
                      mobile={
                        fleetTracking?.data?.rider_data?.[0]?.mobile ||
                        "Unknown Mobile"
                      }
                      qrCode={
                        fleetTracking?.data?.rider_data?.[0]?.qrCode ||
                        "Unknown QR Code"
                      }
                      trackingData={fleetTracking?.data?.tracking_data || []}
                    />
                  </Grid>
                  <Grid item sx={{ width: "70%" }}>
                    <div style={{ width: "100%", height: "23rem" }}>
                      <GoogleLive
                        trackingData={fleetTracking?.data?.tracking_data || []}
                      />
                    </div>
                    <div className="border-solid border-2	border-[#06B681] rounded-lg	p-2 w-full mt-4">
                      <div className="flex justify-between">
                        <div className="flex">
                          <p className="text-left mb-2">Speed Graph</p>
                        </div>
                        <div className="flex">
                          <div className="border-solid border-2	border-[#06B681] rounded-lg	p-1 mr-1">
                            <small>
                              {
                                fleetTracking?.data?.tracking_data?.[0]
                                ?.Increamental_Distance
                              }{" "}
                              KM
                            </small>
                          </div>
                          <div className="border-solid border-2	border-[#06B681] rounded-lg	p-1 mr-1">
                            <small>
                              {fleetTracking?.data?.rider_data?.[0]?.qrCode}
                            </small>
                          </div>
                          <div className="border-solid border-2	border-[#06B681] rounded-lg	p-1">
                            <small>
                              {fleetTracking?.data?.rider_data?.[0]?.fleet_name}
                            </small>
                          </div>
                        </div>
                      </div>
                      <LineChart width={700} height={100} data={speedData}>
                        <CartesianGrid vertical={false} horizontal={false} />
                        <XAxis dataKey="time" tick={{ fontSize: 10 }}>
                          <Label value="Time ->" fontSize={11} dy={16} />
                        </XAxis>
                        <YAxis tick={{ fontSize: 10 }} />
                        <Tooltip />
                        <Line
                          type="monotone"
                          dataKey="speed"
                          stroke="blue"
                          name="Speed"
                          dot={false}
                        />
                      </LineChart>
                      <div className="flex justify-between">
                        <div className="flex">
                          <p className="text-left">
                            {" "}
                            {formatDate(
                               fleetTracking?.data?.tracking_data?.[
                                fleetTracking?.data?.tracking_data?.length - 1
                              ]?.createdTime
                              
                            )}
                          </p>
                        </div>
                        <div className="flex">
                          <p className="text-left">
                            {" "}
                            {formatDate(
                              fleetTracking?.data?.tracking_data?.[0]
                              ?.createdTime
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <CSVLink
                        data={fleetTracking?.data?.tracking_data || []}
                        headers={trackingReportButton}
                        filename={`Tracking_Report_Button.csv`}
                        style={{ marginRight: "10px" }}>
                        <Button
                          sx={{
                            backgroundColor: "#171F21",
                            "&:hover": {
                              backgroundColor: "#63dd99",
                            },
                          }}
                          className="bg-green-500 hover:bg-green-400"
                          fullWidth
                          size="large"
                          variant="contained"
                          type="submit">
                          Download Report
                        </Button>
                      </CSVLink>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};
export default FleetTracking;
